import { render } from "./HeroiconsSolidCash.vue?vue&type=template&id=71d153fc"
const script = {}

import exportComponent from "/Users/yllndritb/Projects/rent/rent-api/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCash.vue"]])

export default __exports__